<template>
  <div>
    <router-view></router-view>
    <modal-error></modal-error>
  </div>
</template>

<script>
import persistentData from "@/plugins/persistentData"
import interceptor from "@/plugins/interceptor"
import ModalError from "@/components/ModalError"

export default {
  components: {
    ModalError
  },
  async created() {
    const token = persistentData.getData('token')
    if (token) {
      const expiration = await interceptor.validateToken()
      if (expiration && this.$route.path == '/') this.$router.push('/list/games')
    } else {
      this.$router.push(`/login`)
    }
  }
};
</script>

<style>
  .md-progress-bar {
    width: 100%;
  }
</style>
